var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConfirmationIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 69,
    rx: 34.5,
    fill: "#CDF9F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 54.5C45.0457 54.5 54 45.5457 54 34.5C54 23.4543 45.0457 14.5 34 14.5C22.9543 14.5 14 23.4543 14 34.5C14 45.5457 22.9543 54.5 34 54.5ZM43.184 29.421C43.6926 28.7671 43.5748 27.8246 42.9209 27.316C42.267 26.8074 41.3246 26.9252 40.816 27.5792L32.802 37.8829C32.6238 38.112 32.2886 38.1417 32.0728 37.9476L27.0035 33.3851C26.3877 32.8309 25.4393 32.8809 24.8851 33.4966C24.3309 34.1124 24.3808 35.0608 24.9966 35.615L30.0659 40.1774C31.5762 41.5367 33.9226 41.3285 35.17 39.7247L43.184 29.421Z",
    fill: "#00D694"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConfirmationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/confirmationIcon.ce225df53fbb84fd0cf1ddb35ded8a0e.svg";